import React, {useEffect, useState} from 'react';
import axios from "axios";
import {
    Card,
    CardContent,
    Typography,
    Dialog,
    DialogContent,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Snackbar,
    Alert
} from '@mui/material';
import NomenclatureEnum from "../../../enums/nomenclatureEnum";

const collectAllObjects = (node) => {
    let items = [node];
    if (node.childrenPermitTypes?.length) {
        node.childrenPermitTypes.forEach(child => {
            items = items.concat(collectAllObjects(child));
        });
    }
    return items;
};

const NomenclatureChange = () => {
    const [permitTree, setPermitTree] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDepartment, setOrderDepartment] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                setPermitTree(response.data.data.slice(0, 3));
            } catch {}
        };
        void fetchData();
    }, []);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDepartament`);
                if (response.data.success) {
                    setDepartments(response.data.data);
                }
            } catch (error) {
            }
        };

        void fetchDepartments();
    }, []);

    const handleClick = (item) => {
        const allItems = collectAllObjects(item);
        setSelectedItems(allItems);
        setOpenDialog(true);
    };

    const handleSave = async () => {
        const requests = selectedItems.map(item => {
            const {id, ...rest} = item;
            const payload = {...rest, permitTypeId: id, departmentId: orderDepartment};
            return axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdatePermitType`, payload);
        });
        try {
            await Promise.all(requests);
            setShowSuccess(true);
        } catch {}
        setOpenDialog(false);
        setOrderDepartment(null);
        setSelectedItems([]);
    };

    return (
        <>
            <div style={{
                padding: '20%',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                backgroundColor: 'white',
                borderRadius: 15,
                width: '100%',
                alignItems: 'center',
            }}>
                {permitTree.map(item => (
                    <Card key={item.id} onClick={() => handleClick(item)} style={{minWidth: 600, cursor: 'pointer'}}>
                        <CardContent>
                            <Typography variant="h6">{item.title}</Typography>
                        </CardContent>
                    </Card>
                ))}
            </div>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                <DialogContent>

                    <FormControl fullWidth style={{marginBottom: '20px'}}>
                        <InputLabel id="department-label">დეპარტამენტი</InputLabel>
                        <Select
                            labelId="department-label"
                            value={orderDepartment}
                            label="დეპარტამენტი"
                            onChange={(e) => setOrderDepartment(e.target.value)}
                        >
                            {departments.map((department) => (
                                <MenuItem key={department.id} value={department.id}>
                                    {department.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <div style={{display: 'flex', gap: 10, marginTop: 15}}>
                        <Button variant="contained" color="error" onClick={() => setOpenDialog(false)}>
                            დახურვა
                        </Button>
                        <Button
                            disabled={orderDepartment === null}
                            variant="contained"
                            onClick={handleSave}
                        >
                            შენახვა
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
            <Snackbar
                open={showSuccess}
                autoHideDuration={3000}
                onClose={() => setShowSuccess(false)}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert severity="success" onClose={() => setShowSuccess(false)} sx={{width: '100%'}}>
                    წარმატებით განახლდა
                </Alert>
            </Snackbar>
        </>
    );
};

export default NomenclatureChange;
